import { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { TableExt, TableInfo, GridBox } from 'libs/ui';
import { NewTicketAction } from './actions/new-ticket-action';
import { getTableParams } from './grid.params';
import { path } from 'router/sections';

export const StayGrid = (props) => {
  const { disableClick, count, count_limit, count_method, getFilter, entries, className, theme, getXlsAction, clientId } = props;

  const { t } = useTranslation();
  const history = useHistory();

  const rightView = user.haveRight('stays.view');

  /**
   * open new tab with stay card
   * @param {*} row
   * @returns
   */
  const onRowDblClick = (row) => {
    if (disableClick === true) {
      return;
    }
    window.open(path('stay') + '?id=' + row.id, '_blank', 'noopener,noreferrer');
  };

  const onRowClick = (row) => {
    if (disableClick === true) {
      return;
    }
    history.push(path('stay') + '?id=' + row.id);
  };

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // top actions
  const topActions = [];
  topActions.push({ cmp: <NewTicketAction key="new-ticket-action" withoutInfo refresh={props.refresh} /> });
  if (count) {
    getXlsAction(topActions);
  }
  const tableParams = useMemo(() => getTableParams(Boolean, t), [t]);

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} count_limit={count_limit} count_method={count_method} getFilter={getFilter} actions={topActions} />

      <TableExt
        getFilter={getFilter}
        theme={theme}
        title={t('sections.Парковки')}
        rows={{ count, items }}
        className={className}
        refresh={props.refresh}
        clientId={clientId}
        onRowClick={rightView ? onRowClick : undefined}
        onRowDblClick={rightView ? onRowDblClick : undefined}
        {...tableParams}
      />
    </GridBox>
  );
};
